module.exports = "/images/INTER..png?7e80124abea07e21e98abbc36b8542c8";